"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_rating__0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aac8c4ba-4350-4eec-8b5a-6c36938534bd",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 160"
  }, props), /*#__PURE__*/React.createElement("title", null, "number-0"), /*#__PURE__*/React.createElement("g", {
    id: "970649ad-f7f9-4f81-b7f5-7238b875e11e",
    "data-name": "Download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a81b02cf-bd9a-44de-bc8b-f90679b79c8d",
    "data-name": "Cloud_download"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.9,114.46c-2.77,9.38-10,17.66-20.07,17.66s-17.2-8.29-20-17.66l-.13-.49a70.07,70.07,0,0,1,.13-36.56h0c2.77-9.38,9.93-17.66,20-17.66S113.13,68,115.9,77.42h0A70.07,70.07,0,0,1,116,114Z",
    transform: "translate(-16 -16)",
    strokeMiterlimit: 10
  }))));
}

var _default = ic_rating__0;
exports.default = _default;